import script from "./CoreUiClientInfoRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoreUiClientInfoRow.vue?vue&type=script&lang=ts&setup=true"

import "./CoreUiClientInfoRow.vue?vue&type=style&index=0&id=7d510b7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d510b7e"]])

export default __exports__